import { gql } from '@apollo/client'
import { MUTATION_STATE } from 'api/fragments'

const PAYLOAD_TYPE = 'UpdateVoohCreationMediaPayload'

export const UPDATE_VOOH_CREATION_MEDIA = gql`
  ${MUTATION_STATE(PAYLOAD_TYPE)}
  mutation updateVoohCreationMedia(
    $voohCreationId: ID!
    $media: [VoohMediumUsage!]!
  ) {
    updateVoohCreationMedia(
      input: {
        voohCreationId: $voohCreationId
        media: $media
      }
    ) {
      ...MutationState${PAYLOAD_TYPE}Fields
    }
  }
`
